import type { ContentCatalog } from "@bsim/contracts";
import type { ComplexityLevel, DecisionId } from "@bsim/domain";

/**
 * The decisions the player can move in a round at `level`. A guided round opens the focus decisions of each family and, from `roundNo`, each `later` one at its own opening round
 * (the api's rule, `catalog/guided.ts`); an executive round opens all of them, including those a guided round's catalog kept as `policyDecisions`. Without `roundNo` only the opening ones count.
 */
export const openDecisionIds = (catalog: ContentCatalog, level: ComplexityLevel, roundNo?: number): ReadonlySet<DecisionId> => {
  const focus = catalog.focusDecisions;
  if (level === "guided" && focus !== null) {
    return new Set(Object.values(focus.families).flatMap((f) => [...f.opening, ...(roundNo === undefined ? [] : f.later.filter((id) => roundNo >= (catalog.guided?.opensInRound[id] ?? focus.openingThroughRound + 1)))]));
  }
  return new Set([...catalog.decisions.map((d) => d.decisionId), ...(roundNo === undefined ? [] : (catalog.policyDecisions ?? []).map((d) => d.decisionId))]);
};
